export const footerTranslations = {
  en: {
    account: 'Account',
    company: 'Company',
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    manageSubscription: 'Manage subscription',
    accountDeletion: 'Delete account',
    contact: 'Contact',
    imprint: 'Imprint',
    aboutUs: 'About us',
    resources: 'Resources',
    manifesto: 'Manifesto',
    youtube: 'Youtube',
    copyright: 'Finley',
  },
  de: {
    account: 'Konto',
    company: 'Unternehmen',
    legal: 'Rechtliches',
    privacyPolicy: 'Datenschutz',
    termsOfService: 'Nutzungsbedingungen',
    cookiePolicy: 'Cookie-Richtlinie',
    manageSubscription: 'Abo verwalten',
    accountDeletion: 'Konto löschen',
    contact: 'Kontakt',
    imprint: 'Impressum',
    aboutUs: 'Über uns',
    resources: 'Ressourcen',
    manifesto: 'Manifest',
    youtube: 'Youtube',
    copyright: 'Finley',
  },
} as const

export type FooterLocale = keyof typeof footerTranslations
